import React from 'react';

import Icon from './Icon';
import { loadingGrey } from '../constants/colors';

const Loading = () => (
  <div
    // eslint-disable-next-line react/no-unknown-property
    styles={{
      alignItems: 'center',
      display: 'flex',
      height: '100vh',
      justifyContent: 'center',
    }}
  >
    <Icon fill={loadingGrey} height="30px" type="loading" width="120px" />
  </div>
);

export default Loading;

